<template>
    <div class="consultation">
        <div class="consultation-box">
            <strong>隐私问题咨询</strong>
            <div style="line-height: 30px;">欢迎您登录星河隐私问题咨询页面行使您的数据主体权利，并就您的个人数据处理问题与星河联系。请选择您需要咨询的问题类型。</div>
            <div style="line-height: 30px;">我们将处理和保留您在隐私咨询问题页面提交的数据。这些数据自您最后一次与星河交流之日起最多5年。</div>
            <div style="margin: 25px 0 15px 0;">
                问题类型 *
            </div>
            <el-form :model="form" :rules="rules" ref="form" class="demo-form">
                <div>
                    <el-radio v-model="form.questionType" :label="1">数据删除申请</el-radio>
                    <el-radio v-model="form.questionType" :label="2">隐私问题咨询</el-radio>
                    <el-radio v-model="form.questionType" :label="3">隐私问题投诉</el-radio>
                    <el-radio v-model="form.questionType" :label="4">数据泄露报告</el-radio>
                    <el-radio v-model="form.questionType" :label="5">其他个人信息请求</el-radio>
                    <el-radio v-model="form.questionType" :label="6">个人信息保护负责人联系</el-radio>
                </div>
                <div style="margin: 25px 0 15px 0;">为了更好处理您的诉求或回答您的问题， 请详细描述您的诉求或问题。</div>
                <el-form-item prop="email">
                    <el-input class="input-width" maxlength="50" placeholder="*邮箱" v-model="form.email"></el-input>
                </el-form-item>
                <el-form-item prop="phoneNum">
                    <el-input class="input-width" maxlength="15" placeholder="*手机号" v-model="form.phoneNum"></el-input>
                </el-form-item>
                <el-form-item prop="code">
                    <div class="code-box input-width">
                        <el-input maxlength="4" placeholder="*验证码" v-model="form.code"></el-input>
                        <canvas @click="refreshCaptcha" class="code" id="captchacodeLogin"
                            style="position: absolute;right: 0;height: 100%;"></canvas>

                    </div>

                </el-form-item>
                <el-form-item prop="questionDetail">
                    <el-input show-word-limit class="input-width" maxlength="500" :rows="4" type="textarea" placeholder="*问题详情"
                        v-model="form.questionDetail"></el-input>
                </el-form-item>
            </el-form>
            <div class="input-width">
                <el-button :loading="loading" class="sub" @click="sub">提交</el-button>

            </div>
        </div>

    </div>
</template>
  
<script>
// import GVerify from 'captcha-mini';
import Captcha from 'captcha-mini';
import { consultation } from '@/api/app'

export default {
    data() {
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        const phoneRegex = /^1[3-9]\d{9}$/;
        var checkCode = (rule, value, callback) => {
            if (value.toLowerCase() === this.captchaText.toLowerCase()) {
                callback();
            } else {
                callback(new Error('验证码错误'));
            }

        };
        return {
            loading: false,
            captchaClass: new Captcha({
                fontSize: 80,
            }),
            captchaText: "",
            form: {
                questionType: 2,
                email: "",
                phoneNum: "",
                code: "",
                questionDetail: ""
            },
            rules: {
                email: [
                    { required: true, message: '邮箱不能为空', trigger: 'blur' },
                    { pattern: emailRegex, message: '请输入正确的邮箱格式', trigger: 'blur' }
                ],
                phoneNum: [
                    { required: true, message: '手机号不能为空', trigger: 'blur' },
                    { pattern: phoneRegex, message: '请输入正确的手机号格式', trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '验证码不能为空', trigger: 'blur' },
                    { validator: checkCode, trigger: 'blur' }
                ],
                questionDetail: [
                    { required: true, message: '问题详情不能为空', trigger: 'blur' },
                ]
            }

        };
    },
    methods: {
        refreshCaptcha() {
            const captchaCanvas = document.getElementById('captchacodeLogin');
            if (captchaCanvas) {
                this.captchaClass.draw(captchaCanvas, r => {
                    this.captchaText = r.toLowerCase();
                    console.log(this.captchaText, '验证码');
                });
            }
        },
        sub() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.$confirm('本页面仅受理隐私相关诉求，我们可能无法回复与隐私无关的诉求。如果你有其它与隐私无关的问题，请联系(0551) 65157417。', '温馨提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        customClass:"myClss"
                    }).then(() => {
                        this.loading = true
                        consultation(this.form).then(res => {
                            console.log(res)
                            this.loading = false

                            if (res.code == 200) {
                                this.$message.success("提交成功")
                                this.refreshCaptcha()
                                this.$refs.form.resetFields();
                            }
                        }).catch(() => {
                            this.loading = false
                        })

                    })


                }
            });
        },
    },
    mounted() {
        this.refreshCaptcha()
    },
};
</script>
  
<style scoped lang="scss">
.consultation {
    .consultation-box {
        margin: 50px auto;
        width: 1000px;
    }

    .code-box {
        position: relative;
    }

    .sub {
        text-align: center;
        font-size: 16px;
        height: 38px;
        line-height: 38px;
        color: #fff;
        border-radius: 6px;
        width: 200px;
        margin: 50px auto;
        background-color: #43423e;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
    }


}

::v-deep .el-radio__label {
    font-size: 15px !important;
}

.input-width {
    width: 500px;
}

</style>

<style>
 .el-message-box{
    padding: 18px;
    padding-top: 3px;
    width: 600px;
}
.myClss .el-message-box__message p {
    line-height: 30px;
}
</style>
  